import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import TableHeaderCell from '../../../../../newEditor/tablePart/tableHeaderCell';
import { TableHeaderRow } from '../../../../../newEditor/tablePart/styles';

function Header({
  activeCol, highlights, onToggleHighlight,
}) {
  return (
    <TableHeaderRow className="m-0 px-1 fs-1 d-flex">

      <Col xl={8} lg={8} className="px-0">

        <TableHeaderCell
          className="text-center text-xl-left"
          active={activeCol === 'gas_equpmanet'}
          highlighted={highlights.includes('gas_equpmanet')}
          onToggleHighlight={() => onToggleHighlight('gas_equpmanet')}
        >
          Газоспоживаюче обладнання
        </TableHeaderCell>
      </Col>

      <Col xl={4} lg={4} className="px-0">

        <TableHeaderCell
          className="text-center text-xl-left"
          active={activeCol === 'amount'}
          highlighted={highlights.includes('amount')}
          onToggleHighlight={() => onToggleHighlight('amount')}
        >
          Кількість
        </TableHeaderCell>
      </Col>

    </TableHeaderRow>
  );
}

Header.propTypes = {
  // fields: fieldsPropTypes.isRequired,
  activeCol: PropTypes.string,
  highlights: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleHighlight: PropTypes.func.isRequired,
};

Header.defaultProps = {
  activeCol: null,
};

export default Header;
